import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/advertiser/_layout")({
    component: () => <AdvertiserLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.report.advertiser.title"),
        asActive: true,
    }),
});

function AdvertiserLayout() {
    return <Outlet />;
}